import { useEffect } from "react";

import { useLocation, useNavigationType } from "react-router-dom";

import { scrollPageToTop } from "../components/helpers/scrollPageToTop";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    if (navType === "POP") {
      return;
    }

    scrollPageToTop();
  }, [pathname, navType]);

  return null;
}
